import { render, staticRenderFns } from "./single.vue?vue&type=template&id=4ca5c196&scoped=true&"
import script from "./single.vue?vue&type=script&lang=js&"
export * from "./single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5c196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca5c196')) {
      api.createRecord('4ca5c196', component.options)
    } else {
      api.reload('4ca5c196', component.options)
    }
    module.hot.accept("./single.vue?vue&type=template&id=4ca5c196&scoped=true&", function () {
      api.rerender('4ca5c196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/files/single.vue"
export default component.exports